module.exports = __webpack_public_path__ + "media/images/lb/146-17585ce5ca8a8674c467dc91cbfc426a.svg";